<template>

  <header class="flex flex-col items-center justify-center bg-center md:bg-cover bg-no-repeat  bg-[url('@/assets/backgroundMobile.png')] lg:bg-[url('@/assets/background.png')]">
    
    <div class="w-full flex flex-col items-center justify-center py-10">
      <img class="object-contain w-10/12 lg:w-6/12" src="@/assets/logo.png" />

      <div class="flex flex-col md:flex-row w-full md:w-auto gap-2 md:gap-4 px-5 text-center mt-5">
        <router-link to="/" class="px-5 py-2 border border-black bg-transparent text-black font-semibold hover:bg-black hover:text-white rounded-md" >
          <i class="pi pi-check mr-2"></i>SOY INVITADO
        </router-link>
        <router-link to="/prensa" class="px-5 py-2 border border-black bg-transparent text-black font-semibold hover:bg-black hover:text-white rounded-md" >
          <i class="pi pi-check mr-2"></i>SOY PRENSA
        </router-link>
        <router-link to="/credenciales" class="px-5 py-2 border border-black bg-transparent text-black font-semibold hover:bg-black hover:text-white rounded-md" >
          <i class="pi pi-check mr-2"></i>YA ME ACREDITÉ
        </router-link>
      </div>

    </div>
    
    
  </header>


</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>